import type { FC } from "react";

import { Form } from "@/ui/components/form/Form";

import type {
  TInlineFormProps,
} from "@/ui/components/form/InlineForm/InlineForm.config";
import { InlineFormContent } from "./InlineFormContent";

export const InlineForm: FC<TInlineFormProps> = ({ onSubmit, ...props }) => {
  if (props.asNestedForm) {
    return (
      <InlineFormContent
        {...props}
        onAction={() => {
          void onSubmit();
        }}
      />
    );
  }

  return (
    <Form
      data-component="InlineForm"
      onSubmit={(event) => {
        event.preventDefault();
        void onSubmit();
      }}
    >
      <InlineFormContent {...props} />
    </Form>
  );
};

InlineForm.displayName = "InlineForm";
